module.exports = __webpack_public_path__ + "static/media/apple.c8c829f1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/icons/apple.svg
// module id = 2277
// module chunks = 7